module.exports = __webpack_public_path__ + "img/mapway_1.76c87eb9.jpg";